<template>
  <div class="course-card" :class="'course-card--' + course.courseColor">
    <div class="course-card__box">
    <span class="course-card__id">
      {{course.courseID}}:
    </span>
    <span class="course-card__credits">{{course.courseName}}</span>
    <span class="course-card__credits" v-if="course.hasMin && course.courseCredits !== ''">({{course.min}}-{{course.courseCredits}})</span>
    <span class="course-card__credits" v-if="!course.hasMin && course.courseCredits !== ''">({{course.courseCredits}})</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CourseCard',
  props: ['course'],
  data () {
    return {
      bgc: {
        backgroundColor: this.course.courseColor
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '~styles/vars';
  .course-card {
    font-family: $fNational;
    font-weight: $fRegular;
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 6px;
    min-height: 40px;
    padding-top: 14px;
    padding-bottom: 14px;
    padding-left: 20px;
    padding-right: 20px;
    background: linear-gradient(to right, rgba(0,0,0,0), rgba(0,0,0,0.07));
    border-radius: 2px;
    &--marshall-core {
      background-color: $cMarshallCore;
      // .course-card__id {
      //   font-weight: $fBold;
      //   color: $cWhite;
      // }
      // .course-card__credits {
      //   color: $cWhite;
      // }
    }
    &--marshall-elective{
      background-color: $cMarshallElective;
    }
    &--usc-requirement {
      background-color: $cUSCRequirement;
    }
    &--usc-elective {
      background-color: $cUSCElective;
    }
    &--accounting {
      background-color: $cAccounting;
    }
    &--cinematic-arts {
      background-color: $cCinematicArts;
    }
    &--viterbi-core {
      background-color: $cViterbiCore;
    }
    &--realestate{
      background-color: $cRealEstate;
    }
    &--ai {
      background-color: $cAI;
    }
    &__box {
      padding: 10px;
      border-radius: 2px;
      background: #f7f7f5d9;
    }
    &__id {
      font-weight: $fBold;
      color: $cBody;
    }
    &__credits {
      color: $cBody;
      // white-space: nowrap;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CourseChart/CourseCard.vue